import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import Logo from "./Logo";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const phoneNumber = "05075537051";

  const navLinks = [
    { href: "/", label: "Ana Sayfa" },
    { href: "/hakkimizda", label: "Hakkımızda" },
    { href: "/hizmetlerimiz", label: "Hizmetlerimiz" },
    { href: "/satin-aldigimiz-esyalar", label: "Satın Aldığımız Eşyalar" },
    { href: "/sss", label: "Sık Sorulan Sorular" },
    { href: "/iletisim", label: "İletişim" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="glass-header sticky top-0 z-50 border-b border-slate-200" data-testid="header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0" data-testid="logo-link">
            <Logo />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                data-testid={`nav-link-${link.href.replace("/", "") || "home"}`}
                className={`text-sm font-medium transition-colors hover:text-[#002FA7] ${
                  isActive(link.href) ? "text-[#002FA7]" : "text-slate-700"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Phone Button - Desktop */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href={`tel:${phoneNumber}`}
              data-testid="header-phone-btn"
              className="flex items-center gap-2 bg-[#002FA7] text-white px-4 py-2.5 rounded-lg font-semibold text-sm hover:bg-[#001d6e] transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span>0507 553 70 51</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 text-slate-700"
            data-testid="mobile-menu-btn"
            aria-label="Menüyü aç"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden py-4 border-t border-slate-200" data-testid="mobile-nav">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setIsMenuOpen(false)}
                data-testid={`mobile-nav-link-${link.href.replace("/", "") || "home"}`}
                className={`block py-3 px-2 text-base font-medium transition-colors hover:text-[#002FA7] ${
                  isActive(link.href) ? "text-[#002FA7]" : "text-slate-700"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="mt-4 pt-4 border-t border-slate-200">
              <a
                href={`tel:${phoneNumber}`}
                className="flex items-center justify-center gap-2 bg-[#002FA7] text-white px-4 py-3 rounded-lg font-semibold"
                data-testid="mobile-phone-btn"
              >
                <Phone className="w-5 h-5" />
                <span>0507 553 70 51</span>
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
